import { Toaster } from 'react-hot-toast';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import {
  RouterProvider
} from "react-router-dom";
import { routes } from './routes/routes';

function App() {
  return (
    <div>
      <RouterProvider router={routes}></RouterProvider>
      <MessengerCustomerChat
        pageId="100064918334486"
        appId="794747451808066"

      />
      <Toaster></Toaster>
    </div>
  );
}

export default App;
